/* rt: a cliente tem de escolher o tamanho (Theme settings → rt_size_require_choice).
   O snippets/product-variant-options.liquid marca o seletor do tamanho com .rt-size-unpicked: o rádio
   continua marcado por baixo (o Broadcast precisa de uma variante válida), só o aspeto diz «por escolher».

   1. Um clique DA CLIENTE num tamanho tira a marca. `isTrusted` deixa de fora os .click() automáticos
      (rt-product-options-enhance e rt-quick-add saltam para o 1.º tamanho que existe na cor), e é
      `click` e não `change` porque carregar no tamanho que já está marcado não dispara `change`.
   2. Enquanto a marca lá estiver, o «Ajouter au panier» (o principal, a pílula fixa do telemóvel e o da
      janela de quick-add) não adiciona: mostra o aviso e leva a cliente aos tamanhos. Corre em captura
      no document, antes dos handlers do Broadcast; a pílula precisa de ser apanhada aqui, senão o
      assets/product.js já a deixou em is-loading quando reencaminha o clique. */
(function () {
  if (window.rtSizeRequired) return;
  window.rtSizeRequired = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function clearAlert(wrapper) {
    wrapper.classList.remove('rt-size-unpicked', 'rt-size-alert');
    var msg = wrapper.querySelector('.rt-size-required-msg');
    if (msg) msg.remove();
  }

  // o seletor por escolher que pertence a este botão: janela de quick-add, produto, ou a secção (a pílula
  // fixa vive fora do <product-component>)
  function unpickedFor(btn) {
    var scopes = [btn.closest('[data-quick-add-modal]'), btn.closest('product-component'), btn.closest('.shopify-section')];
    for (var i = 0; i < scopes.length; i++) {
      var hit = scopes[i] && scopes[i].querySelector('.rt-size-unpicked');
      if (hit) return hit;
    }
    return null;
  }

  function ask(wrapper) {
    var msg = wrapper.querySelector('.rt-size-required-msg');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'rt-size-required-msg';
      msg.setAttribute('role', 'alert');
      msg.textContent = wrapper.getAttribute('data-rt-size-msg') || '';
      var fieldset = wrapper.querySelector('fieldset') || wrapper;
      fieldset.insertAdjacentElement('afterend', msg);
    }
    wrapper.classList.remove('rt-size-alert');
    void wrapper.offsetWidth; // recomeça a animação a cada tentativa
    wrapper.classList.add('rt-size-alert');
    wrapper.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var size = e.target.closest('.rt-size-unpicked .radio__button');
    if (size) {
      if (e.isTrusted) clearAlert(size.closest('.rt-size-unpicked'));
      return;
    }

    var btn = e.target.closest('[data-add-to-cart]:not([data-quick-add-btn]), [data-add-to-cart-bar]');
    if (!btn) return;
    var wrapper = unpickedFor(btn);
    if (!wrapper) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    ask(wrapper);
  }, true);
})();
